import { AnimatePresence } from 'framer-motion'
import { motion } from 'framer-motion'
import { CloserLeadDetailsInfoCard } from '@/components/CloserLeads/Modals/CloserLeadDetailsInfoCard'
import { CloserLeadDetailsInfoForms } from '@/components/CloserLeads/Modals/CloserLeadDetailsInfoForms'
import type { CloserLead } from '@/types'

interface CloserLeadDetailsInfoTabProps {
  lead: CloserLead
  showRegForm: boolean
  setShowRegForm: (v: boolean) => void
  showDiscardForm: boolean
  setShowDiscardForm: (v: boolean) => void
  regCanal: string
  setRegCanal: (v: string) => void
  regResultado: string
  setRegResultado: (v: string) => void
  regObs: string
  setRegObs: (v: string) => void
  onRegisterSubmit?: () => void
  onConvertToDeal: (id: string) => void
  onDiscardLead?: (status: string, motivo: string) => void
}

export function CloserLeadDetailsInfoTab(props: CloserLeadDetailsInfoTabProps) {
  const { lead, showRegForm, showDiscardForm } = props
  const showingForm = showRegForm || showDiscardForm

  return (
    <motion.div key='info' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className='flex-1 overflow-y-auto space-y-4'>
      <div className='glass-card p-6 relative overflow-hidden'>
        <div className='absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-accent/40 to-transparent' />
        <AnimatePresence mode='wait'>
          {!showingForm ? (
            <CloserLeadDetailsInfoCard lead={lead} />
          ) : (
            <CloserLeadDetailsInfoForms {...props} />
          )}
        </AnimatePresence>
      </div>
      {!showingForm && <CloserLeadDetailsInfoForms {...props} />}
    </motion.div>
  )
}
